import React, { useEffect, useState } from 'react';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { siteOptions } from '../../constants';

const WarningDialog = () => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    const siteOptionsObj = JSON.parse(localStorage.getItem(siteOptions) || '{}');
    siteOptionsObj.doNotShowWarninDialog = true;
    localStorage.setItem(siteOptions, JSON.stringify(siteOptionsObj));
    setOpen(false);
  };

  useEffect(() => {
    // let siteOptionsObj = localStorage.getItem(siteOptions);
    // if (siteOptionsObj) {
    //   siteOptionsObj = JSON.parse(siteOptionsObj);
    //   if (!siteOptionsObj?.doNotShowWarninDialog || siteOptionsObj?.doNotShowWarninDialog !== true) {
    //     setOpen(true);
    //   }
    // } else {
    //   setOpen(true);
    // }
  }, []);

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      className="tp-how-new-order__modal"
    >
      <DialogTitle>
        <Box sx={{
          display: 'flex',
          flexFlow: 'row nowrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
        }}
        >
          <b>Önemli Uyarı</b>
          <IconButton
            aria-label="close"
            onClick={handleClose}
          >
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Typography>
          <p><b>Sayın Müşterimiz,</b></p>
          <p>
            <strong>joobid.com</strong>
            {' '}
            ve
            {' '}
            <strong>musteri.joobid.com</strong>
            {' '}
            adresi dışında resmi bir web sitesi bulunmamaktadır. Çeşitli mecralar üzerinden teklifplatformu1, teklifplatformu01 vb. ünvan ve logosu kullanılarak düzenlenen sahte web sitelerinin şirketimizle hiçbir ilgisi yoktur.
            Olumsuz bir durumla karşılaşmanızı önlemek amacıyla adres çubuğunda yazılı site adı ve uzantısını kontrol etmenizi,
            <strong> joobid.com</strong>
            {' '}
            ve
            {' '}
            <strong>musteri.joobid.com</strong>
            {' '}
            adresi hariç herhangi bir web sitesi linkine tıklamamanızı ve bu linkler aracılığıyla kişisel bilgilerinizi paylaşmamanızı önemle rica ederiz.
          </p>
          <p>Saygılarımızla</p>
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default WarningDialog;
